(function (app, GlobalSettings, CheckoutSettings, globalQueryParams) {

    var errorReasons = {
        itemNonLongerAvailable: '_SomeItemsAreNoLongerAvailable'
    };

    var PaymentModel = Backbone.Model.extend({
        initialize: function () {
            _.bindAll(this);

            this._logger = InsightLogger 
                && InsightLogger.beforePayLogger 
                && InsightLogger.beforePayLogger(app.models.summary, false);

            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);

            var success = _.bind(this.success, this, null);
            app.models.masterpass.checkQueryParams(globalQueryParams, success);

            app.checkout.checkTransactionParams(success);
        },

        getCurrentPaymentMethod: function () {
            return app.models.currentMethod.getCurrentMethod();
        },

        _update: function (data) {
            if (!data.IsEmpty) {
                if (data.DeliveryServicePackageDetail && !data.DeliveryServicePackageDetail.Purchased) {
                    this.set('Total', data.DeliveryServicePackageDetail.Amount);
                } else {
                    this.set('Total', data.Summary.Total);
                }
                this.set('ThreeDSecureRequired', data.ThreeDSecureRequired);
                this.set('IsVCOThreeDSecureRequired', data.VisaCheckout && data.VisaCheckout.Settings && data.VisaCheckout.Settings.IsThreeDSecureRequired);
            }
        },

        payWithCurrentMethod: function (paymentMethod) {
            paymentMethod = paymentMethod || this.getCurrentPaymentMethod();
            if (!paymentMethod) {
                return;
            }

            if (paymentMethod.IsMasterPass) {
                window.app && app.event && app.event.currentMasterpass();
                this.payMasterPass(paymentMethod.Token);
            } else if (paymentMethod.IsDirect) {
                window.app && app.event && app.event.directPayment();
                this.payDirect(paymentMethod);
            } else if (paymentMethod.Token) {
                if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.BrainTreePayPal) {
                    window.app && app.event && app.event.currentPayPal();
                    this.payPayPal(paymentMethod);
                }
                else if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.VisaCheckoutBrainTree) {
                    window.app && app.event && app.event.currentVisacheckout();
                    this.payBtVisa(paymentMethod);
				}
				else if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.VisaCheckoutCyberSource) {
                    window.app && app.event && app.event.currentVisacheckout();
	                this.payVisaCheckout(paymentMethod);
                }
                else if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.Stripe){
                    window.app && app.event && app.event.stripeCurrentCreditCard();
                    return this.payStripe(paymentMethod);
                }
                else {
                    window.app && app.event && app.event.currentCreditCard();
                    return this.payBT(paymentMethod);
                }
            }
        },

        _payBase: function (paymentMethod, apiMethod, successHandler, errorHandler) {
            var $result = new $.Deferred();
            if (!paymentMethod) {
                return $result.resolve().promise();
            }

            paymentMethod = this._getPaymentMethodWithDeviceData(paymentMethod);

            var success = _.bind(successHandler, this, paymentMethod.Type);
            
            var data = {
                paymentType: paymentMethod.Type || '',
                selectedPaymentOption: paymentMethod.SelectedPaymentOption || '',
                provider: paymentMethod.Provider || '',
                paymentNonce: paymentMethod.Nonce || '',
                paymentToken: paymentMethod.Token || '',
                deviceData: paymentMethod.DeviceData || ''
            };

            var _logger = this._logger;

            this.getValidator().done(function () {

                if (!IsAuthorized()) {
                    var details = app.getCustomerData();
                    if (!details.isValid) {
                        $result.resolve();
                        return;
                    }
                    data.email = details.email;
                    data.name = details.name;
                    data.parameters = details.parameters;
                }

                if (_logger) {
                    _logger(paymentMethod.Type);
                }

                apiMethod({
                            data: data
                        },
                        { wait: true, preventDoubleRequests: true, hideErrors: !!errorHandler })
                    .done(success).fail(errorHandler || $.noop).always($result.resolve);
            });
            
            return $result.promise();
        },

        _payStripe: function (paymentMethod, successHandler, errorHandler, isOurPay) {
            var $result = new $.Deferred();
            var $resultPromise = $result.promise();

            if (!paymentMethod || ! paymentMethod.id) {
                $result.resolve();
                return $resultPromise;
            }

            var paymentMethodType = 'Stripe';

            var success = _.bind(successHandler, this, paymentMethodType);
            var error = _.bind(errorHandler || $.noop, this);

            var data = {
                paymentType: isOurPay ? CheckoutSettings.PaymentSystemType.mypay : (paymentMethod.paymentType || 'stripe'),
                paymentMethodId: paymentMethod.id
            };

            if (isOurPay) {
                data.paymentType = CheckoutSettings.PaymentSystemType.mypay;
                data.selectedPaymentOption = 'ourpay';
                data.provider = 'stripe';
            }

            var _logger = this._logger;
            var _method = this._getApiPaymentMethod();

            this.getValidator().done(function() {

                if (!IsAuthorized()) {
                    var details = app.getCustomerData();
                    if (!details.isValid) {
                        $result.resolve();
                        return $resultPromise;
                    }
                    data.email = details.email;
                    data.name = details.name;
                    data.parameters = details.parameters;
                }

                if (_logger) {
                    _logger(paymentMethodType);
                }

                _method({ data: data }, { wait: true, preventDoubleRequests: true, hideErrors: !!errorHandler })
                    .then(app.stripe.handleServerResponce)
                    .then(function(result) {
                        if (typeof (result) === "string") {
                            delete data.paymentMethodId;
                            data.paymentIntentId = result;

                            return _method({ data: data },
                                { wait: true, preventDoubleRequests: true, hideErrors: !!errorHandler });
                        }
                        return result;
                    })
                    .then(function(result) {
                        if (!result.Result || !result.Value.isPaid || result.Value.response === 'basket_changed') {
                            error(result);
                        } else {
                            success(result);
                        }
                    })
                    .fail(error)
                    .always($result.resolve);
            });

            return $resultPromise;
        },

        payNewOurPay: function (errorHandler) {

            var validator = this.getValidator();

            var validatorResult = validator.process().then(this.addressVerification);

            var hostedFieldsResult = app.Braintree.hostedFields.getPayload();

            $.when(hostedFieldsResult, validatorResult)
                .then(_.bind(function (paymentMethod) {
                    validator.processPhoneVerification(true)
                        .then(_.bind(function () {
                            this._payWithOurPay(paymentMethod, errorHandler);
                        }, this));
                }, this));
        },

        payOurPay: function (paymentMethod, errorHandler) {
            this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(this.getValidator().processPhoneVerification, this, true))
                .then(_.bind(function () {
                    this._payWithOurPay(paymentMethod, errorHandler);
                }, this));
        },

        payNewStripeOurPay: function () {
            var validator = this.getValidator();
            var validatorResult = validator.process().then(this.addressVerification);
            var hostedFieldsResult = app.stripe.getPayload();

            return $.when(hostedFieldsResult, validatorResult)
                .then(_.bind(function (paymentMethodId) {
                    validator.processPhoneVerification(true)
                        .then(_.bind(function () {
                            return this._payStripe({ id: paymentMethodId }, this.success, this._stripeCardErrorHandler, true);
                        }, this));
                }, this))
                .fail(this._stripeCardErrorHandler);
        },

        payStripeOurPay: function (paymentMethod) {
            this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(this.getValidator().processPhoneVerification, this, true))
                .then(_.bind(function () {
                    return this._payStripe({ id: paymentMethod.Token }, this.success, this._stripeCardErrorHandler, true);
                }, this));
        },

        payStripePaymentRequest: function (data) {
            return this._payStripe(data, this.success, this._stripeCardErrorHandler, false);
        },

        payNewBtVisa: function (payload) {
            var method = {
                Nonce: payload.nonce,
                Type: "visacheckoutbraintree",
                SelectedPaymentOption: "visacheckoutbraintree"
            };

            this.getValidator().process()
                .then(this.addressVerification)
                .then(this.getValidator().processPhoneVerification)
                .then(_.bind(function () {
                    this._payWithBraintree(method, this.get('IsVCOThreeDSecureRequired'));
                }, this));
            
        },

        payBtVisa: function (paymentMethod) {
            paymentMethod.Type = paymentMethod.SelectedPaymentOption = 'visacheckoutbraintree';
            this.getValidator().process()
                .then(this.addressVerification)
                .then(this.getValidator().processPhoneVerification)
                .then(_.bind(function () {
                    this._payWithBraintree(paymentMethod, this.get('IsVCOThreeDSecureRequired'));
                }, this));
		},

        payNewBT: function() {

            var validator = this.getValidator();

            var validatorResult = validator.process().then(this.addressVerification);

            var hostedFieldsResult = app.Braintree.hostedFields.getPayload();

            return $.when(hostedFieldsResult, validatorResult)
                .then(_.bind(function(paymentMethod) {
                    return validator.processPhoneVerification()
                        .then(_.bind(function() {
                            paymentMethod.SelectedPaymentOption = "braintree";
                            return this._payWithBraintree(paymentMethod, this.get('ThreeDSecureRequired'));
                        }, this));
                }, this));
        },

        payNewStripe: function() {
            var validator = this.getValidator();
            var validatorResult = validator.process().then(this.addressVerification);
            var hostedFieldsResult = app.stripe.getPayload();
            return $.when(hostedFieldsResult, validatorResult)
                .then(_.bind(function(paymentMethodId) {
                    return this._payStripe({ id: paymentMethodId }, this.success, this._stripeCardErrorHandler, false);
                }, this))
                .fail(this._stripeCardErrorHandler);
        },

        payStripe: function (paymentMethod) {
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    return this._payStripe({ id: paymentMethod.Token }, this.success, this._stripeCardErrorHandler, false);
                }, this));
        },

        payBT: function (paymentMethod) {
            paymentMethod.SelectedPaymentOption = "braintree";
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(this.getValidator().processPhoneVerification)
                .then(_.bind(function () {
                    return this._payWithBraintree(paymentMethod, this.get('ThreeDSecureRequired'));
                }, this));
        },

        payDirect: function (paymentMethod) {
            paymentMethod.SelectedPaymentOption = "";
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    return this._payWithBraintree(paymentMethod, this.get('ThreeDSecureRequired'));
                }, this));
        },

        payHumm: function () {

            var isAuth = IsAuthorized();

            return this.getValidator().process()
                .then(this.addressVerification)
                .then(this.getValidator().processPhoneVerification)
                .then(function() {
                    return app.checkout.payHumm();
                });
        },

        payPayPal: function (paymentMethod) {
            var _errorHandler = _.bind(this._btPayPalErrorHandler, this);
            this.getValidator().process()
                .then(this.addressVerification)
                .then(this.getValidator().processPhoneVerification)
                .then(_.bind(function () {
                    this._payWithBraintreePaypal(paymentMethod, _errorHandler);
                }, this));
        },

        _payWithBraintreePaypal: function (paymentMethod, errorHandler) {
            errorHandler = errorHandler || _.bind(this._btPayPalErrorHandler, this);
            paymentMethod.SelectedPaymentOption = 'braintreePayPal';
            this.__payWithBraintreePaypal(paymentMethod, errorHandler);
        },

        _payWithBraintreePaypalCredit: function (paymentMethod, errorHandler) {
            paymentMethod.SelectedPaymentOption = 'brainTreePayPalCredit';
            this.__payWithBraintreePaypal(paymentMethod, errorHandler);
        },

        __payWithBraintreePaypal: function (paymentMethod, errorHandler) {
            this.getValidator().processPhoneVerification()
                .then(_.bind(function () {
                    this._payBase(paymentMethod, this._getApiPaymentMethod(), this.success, errorHandler);
                }, this));
        },

        _payWithBraintreeVisaCheckout: function (paymentMethod, errorHandler) {
            this._payBase(paymentMethod, this._getApiPaymentMethod(), this.success, errorHandler);
        },

        _payWithBraintree: function (paymentMethod, is3dsRequired, errorHandler) {

            var _errorHandler = _.bind(this._btCardErrorHandler, this, paymentMethod, errorHandler);

            return this.verify3DS(paymentMethod, is3dsRequired)
                .then(_.bind(function (method) {

                    return this._payBase(method, this._getApiPaymentMethod(), this.success, _errorHandler);

                }, this));
        },

        _payWithOurPay: function (paymentMethod, errorHandler) {
            var method = _.extend({}, paymentMethod, {
                Type: CheckoutSettings.PaymentSystemType.mypay,
                SelectedPaymentOption: 'ourpay',
                Provider: 'braintree'
            });
            this._payWithBraintree(method, app.models.ourpay.is3DsRequired(), errorHandler);
        },

        _btCardErrorHandler: function (method, errorHandler, result) {
            if (!result || this._handleErrorResult(result)) {
                return;
            }

            /* Check if 3ds required and try to verify card */
            if (result.Value && result.Value.threeDsRequired) {

                /* set 3ds required */
                app.models.ourpay.is3DsRequired();
                this.set('ThreeDSecureRequired', true);

                if (method.isNew) {
                    app.Braintree.hostedFields.getPayload()
                        .then(_.bind(this._tryToVerify3dsAndPay, this, result))
                        .fail(_.bind(this._tryToVerify3dsAndPay_failed, this, errorHandler));
                } else {
                    this._tryToVerify3dsAndPay(result, method)
                        .fail(_.bind(this._tryToVerify3dsAndPay_failed, this, errorHandler));;
                }
            } else if (!result.Result) {
                /* Check response and display message if Result = false*/
                this._popup(result.Message);
                return;
            } else {
                $.isFunction(errorHandler) && errorHandler(result);
            }
        },

        _btPayPalErrorHandler: function (result) {
            if (!result || this._handleErrorResult(result)) {
                return;
            }

            if (result.Result === false && result.Message) {
                this._popup(result.Message);
            } 
        },

        _stripeCardErrorHandler: function (result) {
            if (!result || this._handleErrorResult(result)) {
                return;
            }

            if (result.Result === false && result.Message) {
                this._popup(result.Message);
            } else if (result.Value && result.Value.response === 'basket_changed') {
                this._popup(GetPageTemplate('_OrderTotalsChanged'));
                app.checkout.update_checkout();
            } else if (result.error && result.error.message) {
                this._popup(result.error.message);
            } else if (typeof (result) === 'string') {
                this._popup(result);
            }
        },

        _handleErrorResult: function(result) {

            if (result && result.Value === errorReasons.itemNonLongerAvailable) {
                // - send event
                if (window.app && app.event && app.event.itemNonLongerAvailable) {
                    app.event.itemNonLongerAvailable();
                }
                // - display message with ok button
                this._popupOk(result.Message);
                // - update basket
                app.checkout.update_checkout();

                return true;
            }
            return false;
        },

        _tryToVerify3dsAndPay: function (result, method) {

            var $result = new $.Deferred();

            this.verify3DS(method, true)
                .then(_.bind(function (paymentMethod) {

                    if (paymentMethod.IneligibleFor3D) {

                        $result.reject(result);

                    } else {

                        var $def = new $.Deferred();
                        
                        $def.promise().done(this.success).fail($result.reject);

                        this._payBase(paymentMethod, this._getApiPaymentMethod(), $def.resolve, $def.reject);
                    }

                }, this));

            return $result.promise();
        },

        _tryToVerify3dsAndPay_failed: function (errorHandler, result) {

            if (!result.Result) {

                this._popup(result.Message);

            } else {

                result.Value &&
                    result.Value.errorMessage &&
                    this._popup(result.Value.errorMessage);

                $.isFunction(errorHandler) && errorHandler(result);

            }

        },

        payMasterPass: function (token) {
            this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    app.models.masterpass.pay(token, _.bind(this.success, this, null), _.bind(this._mastepassErrorHandler, this));
                }, this));
        },

        _mastepassErrorHandler: function(result) {
            if (!result || this._handleErrorResult(result)) {
                return;
            } else if(result.Result === false && result.Message) {
                this._popup(result.Message);
            }
        },

        payIPay: function () {
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    app.checkout.redirectToIPay();
                }, this));
        },

        payAfterpay: function () {
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    var afterpaySrc = CheckoutSettings.getBasketSettings().AfterpaySrc;

                    var isAuth = IsAuthorized();

                    var apiMethod = isAuth ? api.createAfterpayOrder : api.createPublicAfterpayOrder;
                    var details = isAuth ? null : app.getCustomerData();
                    var returnUrl = location.origin + location.pathname;
                    xhr = _.bind(apiMethod, api)(returnUrl, details);

                    var loadXHR = AfterpayHelper.load(afterpaySrc);
                    return  $.when(xhr, loadXHR).done(function (data) {
                        data = data && data.Value || null;
                        if (data && data.isSuccess && data.token && window.AfterPay) {
                            AfterPay.initialize({ countryCode: GlobalSettings.Iso.toUpperCase() });
                            AfterPay.redirect({ token: data.token });
                        }
                    });

                }, this));
        },

        payOpenpay: function () {
            return this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    var isAuth = IsAuthorized();
                    var apiMethod = isAuth ? api.createOpenpayOrder : api.createPublicOpenpayOrder;
                    var details = isAuth ? null : app.getCustomerData();
                    var returnUrl = location.origin + location.pathname;
                    xhr = _.bind(apiMethod, api)(returnUrl, details);

                    return $.when(xhr).done(function (data) {
                        data = data && data.Value || null;
                        if (data && data.isSuccess) {
                            window.location = data.postUrl;
                        }
                        else {
                            var msg = GetPageTemplate('GeneralTechnicalDifficulties');
                            kos.dialog.error({ message: msg });
                        }
                    });

                }, this));
        },

        prePaymentVisa: function () {
            return this.getValidator()
                .process()
                .then(this.addressVerification);
        },
        
        payVisaCheckout: function (paymentMethod) {

            this._payVisaCheckout({
                callId: paymentMethod.Token
            });

        },

        payNewVisaCheckout: function (paymentMethod) {
            this._payVisaCheckout(paymentMethod);
        },

        _payVisaCheckout: function (paymentMethod) {

            paymentMethod.paymentType = paymentMethod.SelectedPaymentOption = 'visacheckoutcybersource';

            var success = _.bind(this.success, this, null);

            this.getValidator().process()
                .then(this.addressVerification)
                .then(_.bind(function () {
                    var method = this._getApiPaymentMethod();
                    method({ data: paymentMethod }, { wait: true, preventDoubleRequests: true, hideErrors: true })
                        .done(success);
                }, this));

        },

        addressVerification: function () {
            var $def = new $.Deferred();
            this.getValidator().addressVerification()
                .done($def.resolve)
                .fail(_.bind(function (message) {
                    message && this._popup(message);
                    $def.reject();
                }, this));
            return $def.promise();
        },

        success: function (paymentMethodType, result) {
            this.trigger('PaymentSuccess', _.extend(result, {
                paymentMethodType: paymentMethodType
            }));
        },

        error: function (err) { /* ignore this error */ },

        getValidator: function () {
            !this.Validator && (this.Validator = new PaymentModelValidator());
            return this.Validator;
        },

        verify3DS: function (paymentMethod, is3dsRequired) {
            var verify = new $.Deferred();
            var isPayPal = CheckoutSettings.OrderPaymentType.BrainTreePayPal === paymentMethod.OrderPaymentType;

            if (!isPayPal && is3dsRequired && app.Braintree.threeDS.isEnabled()) {
                var threeDS = app.Braintree.threeDS;

                this._getPaymentNonce(paymentMethod)
                    .then(_.bind(function (nonce, bin) {
                        var verifyCard = threeDS.verifyCard(this.get('Total'), nonce, bin, app.models.delivery.current.toJSON());

                        window.app && app.event && app.event.threeDSecureOpen();

                        // TODO: for first version 3ds
                        verifyCard.ready.then(_.bind(function (form, $verify) {
                            this._openDialog(form, $verify, _.bind(threeDS.cancelVerifyCard, threeDS));
                        }, this));

                        verifyCard.verify.then(_.bind(function (payload) {
                            window.app && app.event && app.event.threeDSecurePassed();
                            verify.resolve(_.extend({}, paymentMethod, payload));
                        }, this));

                    }, this));

            } else {
                verify.resolve(paymentMethod);
            }
            return verify.promise();
        },

        _getPaymentNonce: function (paymentMethod) {
            var $def = new $.Deferred();
            if (!paymentMethod.Nonce) {
                api.getPaymentMethodNonce(paymentMethod.Token, { wait: true })
                    .then(function (data) {
                        $def.resolve(data.Value.Nonce, data.Value.Bin);
                    }, $def.reject);
            } else {
                $def.resolve(paymentMethod.Nonce, paymentMethod.Bin);
            }
            return $def.promise();
        },

        // TODO: Move Popup outside (for first version 3ds)
        _openDialog: function (form, $verify, beforeHide) {

            if (this.isPopupOpened) {
                return null;
            } else {
                this.isPopupOpened = true;

                var dialog = kos.dialog.popup({
                    cls: 'threeds-popup__position',
                    closeBtn: false,
                    hideOnClick: false
                });

                dialog.$('.notifier-inner')
                    .empty()
                    .css({ 'background': 'none', 'background-color': '#fff', 'padding': '0' })
                    .append(form);

                dialog.on('beforeHide', _.bind(function () {
                    this.isPopupOpened = false;
                    _.isFunction(beforeHide) && beforeHide();
                }, this));
                $verify.always(dialog.destroy);

                return dialog;
            }
        },

        _popup: function (message) {
            if (message) {
                kos.dialog.popup({
                    cls: 'test-surcharge-notification',
                    closeBtn: true,
                    message: message
                });
            }
        },

        _popupOk: function (message) {
            if (message) {
                var dialog = kos.dialog.popup({
                    cls: 'test-surcharge-notification',
                    closeBtn: true,
                    message: message,
                    buttons: [
                        { 'role': 'okButton', text: 'OK', 'class': 'MiddleButton custom-dialog-go-to-basket' }
                    ]
                });
                dialog.$('.notifier-message').css('padding-bottom','10px');
                dialog.$('@okButton').on('click', dialog.destroy);
            }
        },

        _getPaymentMethodWithDeviceData: function (paymentMethod) {
            return _.extend({}, paymentMethod, {
                DeviceData: app.Braintree.kount.getDeviceData()
            });
        },

        _getApiPaymentMethod: function () {
            var method = IsAuthorized() ? api.createPaymentTransaction : api.createPublicPaymentTransaction;
            return _.bind(method, api);
        },
        validateCheckout: function() {
            return this.getValidator().process()
                .then(this.addressVerification);
        }
    });


    app.models = _.extend({ payment: new PaymentModel() }, app.models);
})(app, GlobalSettings, CheckoutSettings, globalQueryParams);